<div class="section is-footer">
  <div class="container-1280">
    <div class="item-container">
      <div class="item-logo">
        <img [src]="assetUrl('assets/images/shell.svg')" alt="" />
      </div>
      <div class="item-programa-shell">
        <p class="item-title">Programa Shell Box</p>
        <a href="/programa" class="item-link">El programa</a>
        <a href="/preguntas-frecuentes" class="item-link faq">Preguntas Frecuentes</a>
        <a href="/preguntas-frecuentes" class="item-link faqm">Preguntas Frecuentes</a>
        <a
          href="https://www.shell.com.ar/politica-de-privacidad.html"
          class="item-link"
          target="_blank"
          >Política de Privacidad</a
        >
        <a
          href="https://www.shell.com.ar/politica-de-cookies.html"
          class="item-link"
          target="_blank"
          >Política de Cookies</a
        >
      </div>
      <div class="item-programa-shell">
        <p class="item-title">Legales</p>
        <ng-container *ngFor="let term of termsAndConditions">
          <a [href]="(term.file)" target="_blank" class="item-link">{{
            term.name
          }}</a>
        </ng-container>
      </div>
      <div class="item-programa-shell">
        <p class="item-title">Contáctanos</p>
        <p (click)="showModal = true" id="call_center" class="item-link">
          Call Center
        </p>
      </div>
      <div class="item-programa-shell">
        <p class="item-title">Seguinos</p>
        <div class="redes-container">
          <a href="https://www.facebook.com/shellargentina/" target="_blank"
            ><img
              src="/assets/images/facebook.png"
              alt="icon-facebook"
              class="icon-facebook"
          /></a>
         
          <a href="https://www.instagram.com/shell_argentina/" target="_blank"
            ><img
              src="/assets/images/instagram.png"
              alt="icon-instagram"
              class="icon-instagram"

          /></a>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="showModal" class="callcenter-modal-container">
    <div class="callcenter-modal">
      <div class="header">
        <div class="img-container">
          <img [src]="assetUrl('assets/images/shell.svg')" alt="shell" />
        </div>
        <button (click)="showModal = false" class="btn-close"></button>
      </div>
      <div class="body">
        <p class="title">CONTACTO</p>
        <div class="separator"></div>
        <a href="tel:08103338652"
          ><img
            [src]="assetUrl('assets/images/phone-icon.png')"
            alt="telefono"
          />0810-333-8652</a
        >
        <a href="mailto:shellbox@raizen.com.ar"
          ><img
            [src]="assetUrl('assets/images/mail-icon.png')"
            alt="mail"
          />shellbox&#64;raizen.com.ar</a
        >
        <p>NUESTRO HORARIO DE ATENCIÓN ES DE LUNES A VIERNES DE 10 A 16HS</p>
      </div>
    </div>
  </div>
</div>
